// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2ZbyH","infoBtn":"quickbooks_infoBtn__28dRL","formBox":"quickbooks_formBox__2ACE7","formFooter":"quickbooks_formFooter__35Dzd"};